module.exports = __webpack_public_path__ + "static/media/service12.69782039.jpg";